<template>
	<section>
		<b-button @click="openFilters = !openFilters" variant="info"
			>Filtros
			<md-icon
				:icon="
					openFilters ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
				"
			/>
		</b-button>
		<b-collapse :visible="openFilters">
			<b-form @submit.prevent="submit">
				<b-row>
					<b-form-group class="col-lg-2" label="Res ID">
						<b-form-input
							size="sm"
							:class="{ 'active-filter': filters.id }"
							v-model="filters.id"
							type="number"
						/>
					</b-form-group>
					<b-form-group class="col-lg-2" label="Nombre">
						<b-form-input
							size="sm"
							:class="{ 'active-filter': filters.clientFullName }"
							v-model="filters.clientFullName"
							type="text"
						/>
					</b-form-group>
					<b-form-group
						v-if="$hasPermission('filters.airport')"
						class="col-lg-4"
						label="Aeropuertos"
					>
						<multiselect
							:class="{
								'active-filter': filters.airport.length > 0
							}"
							v-model="filters.airport"
							:options="airportsOpts"
							group-label="group"
							group-values="options"
							group-select
							multiple
							label="text"
							track-by="value"
							placeholder="Todos"
							:option-height="10"
							taggable
						>
							<template v-slot:clear >
								<div class="multiselect__clear" @click="filters.airport = []"></div>
							</template>
						</multiselect>
					</b-form-group>
					<b-form-group class="col-lg-4" label="Destinos">
						<multiselect
							:class="{
								'active-filter': filters.destination.length > 0
							}"
							v-model="filters.destination"
							:options="destinationsOpts"
							group-label="group"
							group-values="options"
							group-select
							:multiple="true"
							label="text"
							track-by="value"
							placeholder="Todos"
							:taggable="true"
						>
							<template v-slot:clear >
								<div class="multiselect__clear" @click="filters.destination = []"></div>
							</template>
						</multiselect>
					</b-form-group>
				</b-row>
				<b-row>
					<b-form-group class="col-lg-3" label="Canal de venta">
						<multiselect
							:class="{
								'active-filter': filters.salesChannel.length > 0
							}"
							v-model="filters.salesChannel"
							:options="salesChannelsOpts"
							group-label="group"
							group-values="options"
							group-select
							:multiple="true"
							label="text"
							track-by="value"
							placeholder="Todos"
							:taggable="true"
						>
							<template v-slot:clear >
								<div class="multiselect__clear" @click="filters.salesChannel = []"></div>
							</template>
						</multiselect>
					</b-form-group>
					<b-form-group
						v-if="$hasPermission('filters.supplier')"
						class="col-lg-3"
						label="Proveedor"
					>
						<multiselect
							:class="{
								'active-filter': filters.supplier.length > 0
							}"
							v-model="filters.supplier"
							:options="suppliersOpts"
							group-label="group"
							group-values="options"
							group-select
							multiple
							label="text"
							track-by="value"
							placeholder="Todos"
							taggable
						>
							<template v-slot:clear >
								<div class="multiselect__clear" @click="filters.supplier = []"></div>
							</template>
						</multiselect>
					</b-form-group>
					<b-form-group class="col-lg-3" label="Categoria del servicio">
						<multiselect
							:class="{
								'active-filter': filters.serviceTypeCategory.length > 0
							}"
							v-model="filters.serviceTypeCategory"
							:options="serviceTypesCategoriesOpts"
							group-label="group"
							group-values="options"
							group-select
							multiple
							label="text"
							track-by="value"
							placeholder="Todos"
							taggable
						>
							<template v-slot:clear >
								<div class="multiselect__clear" @click="filters.serviceTypeCategory = []"></div>
							</template>
						</multiselect>
					</b-form-group>
					<b-form-group class="col-lg-3" label="Tipo de servicio">
						<multiselect
							:class="{
								'active-filter': filters.serviceType.length > 0
							}"
							v-model="filters.serviceType"
							:options="serviceTypesOpts"
							group-label="group"
							group-values="options"
							group-select
							multiple
							label="text"
							track-by="value"
							placeholder="Todos"
							taggable
						>
							<template v-slot:clear >
								<div class="multiselect__clear" @click="filters.serviceType = []"></div>
							</template>
						</multiselect>
					</b-form-group>
					<b-form-group class="col-lg-3" label="Estado de servicio">
						<multiselect
							:class="{
								'active-filter': filters.status.length > 0
							}"
							v-model="filters.status"
							:options="statusOpts"
							group-label="group"
							group-values="options"
							group-select
							multiple
							label="text"
							track-by="value"
							placeholder="Todos"
							taggable
						>
							<template v-slot:clear >
								<div class="multiselect__clear" @click="filters.status = []"></div>
							</template>
						</multiselect>
					</b-form-group>

					<b-form-group
						v-if="$hasPermission('filters.webcheckin')"
						class="col-lg-3"
						label="Estado de portal web check-in"
					>
						<multiselect
							:class="{
								'active-filter':
									filters.statusCheckin.length > 0
							}"
							v-model="filters.statusCheckin"
							:options="statusCheckinOpts"
							group-label="group"
							group-values="options"
							group-select
							multiple
							label="text"
							track-by="value"
							placeholder="Todos"
							taggable
						>
							<template v-slot:clear >
								<div class="multiselect__clear" @click="filters.statusCheckin = []"></div>
							</template>
						</multiselect>
					</b-form-group>

					<b-form-group
						v-if="$hasPermission('filters.creationUser')"
						class="col-lg-3"
						label="Usuario creacion"
					>
						<multiselect
							:class="{
								'active-filter':
									filters.statusCheckin.length > 0
							}"
							v-model="filters.creationUser"
							:options="usersOpts"
							group-label="group"
							group-values="options"
							group-select
							multiple
							label="text"
							track-by="value"
							placeholder="Todos"
							taggable
						>
							<template v-slot:clear >
								<div class="multiselect__clear" @click="filters.creationUser = []"></div>
							</template>
						</multiselect>
					</b-form-group>

					<b-form-group
						class="col-lg-2"
						label="Estado de validación"
					>
						<b-form-select
							:class="{ 'active-filter': filters.revisedStatus }"
							v-model="filters.revisedStatus"
							:options="revisedStatusOpts"
						/>
					</b-form-group>
				</b-row>
				<b-row>
					<b-form-group class="col-lg-5">
						<b-form-row>
							<b-col>
								Fecha servicio Desde
								<b-form-datepicker
									:class="{
										'active-filter': filters.pickupStartDate
									}"
									reset-button
									today-button
									size="sm"
									v-model="filters.pickupStartDate"
								/>
							</b-col>
							<b-col>
								Hasta
								<b-form-datepicker
									:class="{
										'active-filter': filters.pickupEndDate
									}"
									reset-button
									today-button
									size="sm"
									v-model="filters.pickupEndDate"
								/>
							</b-col>
						</b-form-row>
					</b-form-group>
					<b-form-group
						v-if="$hasPermission('filters.trip')"
						class="col-lg-1"
						label="Viaje"
					>
						<b-form-select
							:class="{ 'active-filter': filters.trip }"
							size="sm"
							v-model="filters.trip"
							:options="tripOpts"
						/>
					</b-form-group>
					<b-form-group
						class="col-lg-2"
						label="Estado de confirmación"
						v-if="$hasPermission('filters.contactStatus')"
					>
						<b-form-select
							:class="{ 'active-filter': filters.contactStatus }"
							size="sm"
							v-model="filters.contactStatus"
							:options="contactStatusOpts"
						/>
					</b-form-group>
					<b-form-group
						class="col-lg-2"
						label="Pickuptime confirmado"
					>
						<b-form-select
							:class="{
								'active-filter': filters.pickupDatetimeConfirmed
							}"
							size="sm"
							v-model="filters.pickupDatetimeConfirmed"
							:options="pickupConfirmedOpts"
						/>
					</b-form-group>
					<b-form-group
						class="col-lg-2"
						label="Confirmación proveedor"
						v-if="$hasPermission('filters.supplierConfirmation')"
					>
						<b-form-select
							:class="{
								'active-filter': filters.supplierConfirmation
							}"
							size="sm"
							v-model="filters.supplierConfirmation"
							:options="supplierConfirmationOpts"
						/>
					</b-form-group>
				</b-row>
				<b-collapse
					v-model="filters.showAdvancedOptions"
					v-if="$hasPermission('filters.advancedOptions')"
				>
					<b-row>
						<b-form-group class="col-lg-5">
							<b-form-row>
								<b-col>
									Fecha creación Desde
									<b-form-datepicker
										:class="{
											'active-filter':
												filters.creationStartDate
										}"
										reset-button
										today-button
										size="sm"
										v-model="filters.creationStartDate"
									/>
								</b-col>
								<b-col>
									Hasta
									<b-form-datepicker
										:class="{
											'active-filter':
												filters.creationEndDate
										}"
										reset-button
										today-button
										size="sm"
										v-model="filters.creationEndDate"
									/>
								</b-col>
							</b-form-row>
						</b-form-group>
						<b-form-group class="col-lg-5">
							<b-form-row>
								<b-col>
									Fecha cancelación Desde
									<b-form-datepicker
										:class="{
											'active-filter':
												filters.cancelationStartDate
										}"
										reset-button
										today-button
										size="sm"
										v-model="filters.cancelationStartDate"
									/>
								</b-col>
								<b-col>
									Hasta
									<b-form-datepicker
										:class="{
											'active-filter':
												filters.cancelationEndDate
										}"
										reset-button
										today-button
										size="sm"
										v-model="filters.cancelationEndDate"
									/>
								</b-col>
							</b-form-row>
						</b-form-group>
						<b-form-group class="col-lg-2" label="Conf. Destinos">
							<b-form-checkbox
								size="sm"
								v-model="filters.placesWithoutCoordinates"
								:value="true"
								:unchecked-value="false"
								>Destinos sin coordenadas</b-form-checkbox
							>
						</b-form-group>
					</b-row>
					<b-row>
						<b-form-group class="col-lg-2" label="Hora servicio">
							<b-row>
								<b-col>
									De: <TimeField v-model="filters.pickupStartTime" />
								</b-col>
								<b-col>
									Hasta: <TimeField v-model="filters.pickupEndTime" />
								</b-col>
							</b-row>
						</b-form-group>
						<b-form-group class="col-lg-2" label="Conf. Tarifas">
							<b-form-checkbox
								size="sm"
								v-model="filters.supplierPriceTotalEmpty"
								:value="true"
								:unchecked-value="false"
								>Tarifa proveedor en 0</b-form-checkbox
							>
						</b-form-group>
						<b-form-group class="col-lg-2" label="Reservas">
							<b-form-checkbox
								size="sm"
								v-model="filters.onlyWithAdditionalServices"
								:value="true"
								:unchecked-value="false"
								>Con servicios adicionales</b-form-checkbox
							>
						</b-form-group>
						<b-form-group class="col-lg-2" label="Reservas">
							<b-form-checkbox
								size="sm"
								v-model="filters.oneway"
								:value="true"
								:unchecked-value="false"
								>OneWay</b-form-checkbox
							>
						</b-form-group>
						<b-form-group class="col-lg-4" label="Zonas Master">
							<multiselect v-model="filters.zones"
								:options="zonedAreasGroupedOpts"
								:multiple="true"
								group-values="zones"
								group-label="zonedArea"
								:group-select="true"
								placeholder="Type to search"
								track-by="text"
								label="text">
									<span slot="noResult">Oops! No se encontraron resultados.</span>
									<template v-slot:clear ><div class="multiselect__clear" @click="filters.zones = []"></div></template>
									<template slot="option" slot-scope="props">
										<div class="option__desc" v-if="props.option.$groupLabel">
											<span class="option__title">{{ props.option.$groupLabel }}</span><br>
										</div>
										<div class="option__desc"  v-else>
											<span class="option__title">{{ props.option.text }}</span><br>
											<small class="option__small text-muted">{{ props.option.zonedAreaName }}</small>
										</div>
									</template>
									<template slot="option-group" slot-scope="props">
										<div class="option__desc">
										<span class="option__title">{{ props.option.text }}</span><br>
										<small class="option__small text-muted">{{ props.option.zonedAreaName }}</small>
										</div>
									</template>
							</multiselect>
						</b-form-group>
					</b-row>
					<b-row>
						<b-form-group label="Etiquetas:" class="col-lg-3">
							<multiselect
							v-model="filters.tags"
							:options="tagsOpts"
							group-label="group"
							group-values="options"
							group-select
							multiple
							label="text"
							track-by="value"
							placeholder="Todos"
							taggable
							>
								<template v-slot:clear >
									<div class="multiselect__clear" @click="filters.tags = []"></div>
								</template>
							</multiselect>
						</b-form-group>
						<b-form-group class="col-lg-2" label="Rango precio venta">
							<b-row>
								<b-col>
									De: <b-form-input :class="{'active-filter':filters.netPriceTotalStart}" v-model="filters.netPriceTotalStart" size="sm" type="number" />
								</b-col>
								<b-col>
									Hasta: <b-form-input :class="{'active-filter':filters.netPriceTotalEnd}" v-model="filters.netPriceTotalEnd" size="sm" type="number" />
								</b-col>
							</b-row>
						</b-form-group>
						<b-form-group class="col-lg-2" label="Rango costo proveedor">
							<b-row>
								<b-col>
									De: <b-form-input :class="{'active-filter':filters.supplierPriceTotalStart}" v-model="filters.supplierPriceTotalStart" size="sm" type="number" />
								</b-col>
								<b-col>
									Hasta: <b-form-input :class="{'active-filter':filters.supplierPriceTotalEnd}" v-model="filters.supplierPriceTotalEnd" size="sm" type="number" />
								</b-col>
							</b-row>
						</b-form-group>
					</b-row>
				</b-collapse>
				<b-row v-if="$hasPermission('filters.salesChannelReference')">
					<b-form-group class="col-lg-2" label="Referencia de Canal">
						<b-form-input
							size="sm"
							:class="{
								'active-filter': filters.salesChannelReference
							}"
							v-model="filters.salesChannelReference"
							type="text"
						/>
					</b-form-group>
					<b-form-group
						class="col-lg-2"
						label="Referencia de Proveedor"
					>
						<b-form-input
							size="sm"
							:class="{
								'active-filter': filters.supplierReference
							}"
							v-model="filters.supplierReference"
							type="text"
						/>
					</b-form-group>
					<b-form-group class="col-lg-2" label="Cliente">
						<b-form-checkbox
							size="sm"
							v-model="filters.containsEmail"
							value="yes"
							unchecked-value=""
							>Tiene email</b-form-checkbox
						>
						<b-form-checkbox
							size="sm"
							v-model="filters.clientEdited"
							value="yes"
							unchecked-value=""
							>Edito la reservación</b-form-checkbox
						>
						<b-form-checkbox
							size="sm"
							v-model="filters.clientConfirmed"
							value="yes"
							unchecked-value=""
							>Confirmo la reservación</b-form-checkbox
						>
					</b-form-group>
					<b-form-group class="col-lg-2" label="Punto de venta">
						<b-form-select
							:class="{
								'active-filter': filters.fromPointOfSale
							}"
							size="sm"
							v-model="filters.fromPointOfSale"
							:options="fromPointOfSaleOpts"
						/>
					</b-form-group>
					<b-form-group class="col-lg-2" label="Rides con">
						<b-form-checkbox
							size="sm"
							v-model="filters.invalidSupplierServiceType"
							:value="true"
							:unchecked-value="false"
							>Supp. service Invalido</b-form-checkbox
						>
						<b-form-checkbox
							size="sm"
							v-model="filters.withSalesChannelPromo"
							:value="true"
							:unchecked-value="false"
							>Sales Channel Promotion(s).</b-form-checkbox
						>
					</b-form-group>
					<b-form-group
						class="col-lg-2 text-right mt-2"
						v-if="$hasPermission('filters.advancedOptions')"
					>
						<b-button
							@click="
								filters.showAdvancedOptions = !filters.showAdvancedOptions
							"
							variant="info"
							class="m-2"
						>
							<span v-if="!filters.showAdvancedOptions"
								>Mostrar opciones avanzadas</span
							>
							<span v-else>Ocultar opciones avanzadas</span>
						</b-button>
					</b-form-group>
				</b-row>
				<b-form-group class="text-right mt-2">
					<b-button class="mr-5" @click="cleanFilters" variant="info"
						>Limpiar</b-button
					>
					<b-button type="submit" variant="primary">Buscar</b-button>
				</b-form-group>
			</b-form>
		</b-collapse>
	</section>
</template>

<script>
import Multiselect from "vue-multiselect";
import TimeField from "../../helpers/TimeField";
// import MainLayout from '../layout/MainLayout.vue'
// import api from '../../../api.js'

export default {
	props: {
		filters: {
			type: Object,
			required: true
		},
		freezFilter: {
			type: Boolean,
			default: false
		}
	},
	components: {
		Multiselect,
		TimeField,
	},
	data() {
		const defaultFilters = {
			id: "",
			clientFullName: "",
			destination: [],
			salesChannel: [],
			supplier: [],
			creationUser: [],
			airport: [],
			serviceType: [],
			serviceTypeCategory: [],
			pickupStartDate: "",
			pickupStartTime: "",
			pickupEndDate: "",
			pickupEndTime: "",
			creationStartDate: "",
			creationEndDate: "",
			cancelationStartDate: "",
			cancelationEndDate: "",
			trip: 0,
			contactStatus: 0,
			revisedStatus: null,
			status: [{ value: "active", text: "Activo" }],
			statusCheckin: [],
			salesChannelReference: "",
			supplierReference: "",
			containsEmail: "",
			clientEdited: "",
			clientConfirmed: "",
			showAdvancedOptions: false,
			pickupDatetimeConfirmed: null,
			fromPointOfSale: null,
			supplierConfirmation: null,
			placesWithoutCoordinates: null,
			supplierPriceTotalEmpty: null,
			onlyWithAdditionalServices: false,
			oneway: false,
			zones:[],
			invalidSupplierServiceType:false,
			withSalesChannelPromo:false,
			tags:[],
			netPriceTotalStart:null,
			netPriceTotalEnd:null,
			supplierPriceTotalStart:null,
			supplierPriceTotalEnd:null,
		};
		return {
			// filters : {...defaultFilters},
			defaultFilters: { ...defaultFilters },
			openFilters: true,

			pickupConfirmedOpts: [
				{ value: null, text: "TODOS" },
				{ value: true, text: "CONFIRMADOS" },
				{ value: false, text: "NO CONFIRMADOS" }
			],
			fromPointOfSaleOpts: [
				{ value: null, text: "TODOS" },
				{ value: true, text: "CON PUNTO DE VENTA" },
				{ value: false, text: "SIN PUNTO DE VENTA" }
			],
			revisedStatusOpts: [
				{ value: null,  text: "Todos" },
				{ value: true,  text: "Validados" },
				{ value: false, text: "No validados" },
			]
		};
	},
	computed: {
		destinationsOpts() {
			return [
				{
					group: "SELECT ALL",
					options: this.$root.auxVars.destinationsOpts
				}
			];
		},
		airportsOpts() {
			return [
				{
					group: "SELECT ALL",
					options: this.$root.auxVars.airportsOpts
				}
			];
		},
		statusOpts() {
			return [
				{
					group: "SELECT ALL",
					options: this.$root.auxVars.transportServiceStatusOpts
				}
			];
		},
		statusCheckinOpts() {
			return [
				{
					group: "SELECT ALL",
					options: this.$root.auxVars.webCheckingStatus
				}
			];
		},
		usersOpts() {
			return [
				{ group: "SELECT ALL", options: this.$root.auxVars.usersOpts }
			];
		},
		contactStatusOpts() {
			let aux = [...this.$root.auxVars.transportServiceContactStatusOpts];
			aux.unshift({ value: 0, text: "Todos" });
			return aux;
		},
		tripOpts() {
			let aux = [...this.$root.auxVars.tripOpts];
			aux.unshift({ value: 0, text: "Todos" });
			return aux;
		},
		salesChannelsOpts() {
			return [
				{
					group: "SELECT ALL",
					options: this.$root.auxVars.salesChannelsOpts
				}
			];
		},
		serviceTypesOpts() {
			return [
				{
					group: "SELECT ALL",
					options: this.$root.auxVars.serviceTypesOpts
				}
			];
		},
		serviceTypesCategoriesOpts() {
			return [
				{
					group: "SELECT ALL",
					options: this.$root.auxVars.serviceTypesCategoriesOpts
				}
			];
		},
		suppliersOpts() {
			return [
				{
					group: "SELECT ALL",
					options: this.$root.auxVars.suppliersOpts
				}
			];
		},
		supplierConfirmationOpts() {
			let options = [{ value: null, text: "TODOS" }];
			options.push.apply(
				options,
				this.$root.auxVars.supplierConfirmationOpts
			);
			return options;
		},
		zonedAreasGroupedOpts(){

			let grouped = [];

			this.$root.auxVars.masterZonedAreasOpts.forEach((ele)=>{
				let item = {
					zonedArea:ele.name,
					zones:ele.zones.map((aux)=>({value:aux.id,text:aux.name,zonedAreaName:ele.name}))
				};
				grouped.push(item)

			})
			return grouped
		},
		tagsOpts() {
			return [
				{
					group: "SELECT ALL",
					options: this.$root.auxVars.tagsOpts
				}
			];
		},

	},
	methods: {
		submit(){
			this.$emit('search')
		},
		cleanFilters() {
			this.$emit("update:filters", { ...this.defaultFilters });
			this.$emit("search");
		}
	},
	mounted() {
		this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: [
				"suppliersOpts",
				"salesChannelsOpts",
				"serviceTypesOpts",
				"airportsOpts",
				"destinationsOpts",
				"usersOpts",
				"masterZonedAreasOpts",
				"serviceTypesCategories",
				"usersOpts",
				"tagsOpts"
			]
		});
		try {

			let filters
			if (this.freezFilter) {
				filters = this.filters
			} else {
				filters = JSON.parse(
					localStorage.getItem(`res-filters-${this.$el.id}`)
				);
			}
			try{
				//URL
				let applyUrl = parseInt(this.$root.getParams()["applyUrl"]?? 0);
				applyUrl     = Boolean(applyUrl)
				if(applyUrl===true){
					filters=this.$root.getParams();
				}
			}catch(err){
				console.log(err)
			}

			if (filters) {
				this.$emit("update:filters", {
					...this.defaultFilters,
					...filters
				});
			}
		} catch (e) {
			localStorage.removeItem(`res-filters-${this.$el.id}`);
		}
	},
	watch: {
		filters: {
			handler(val) {
				if (!this.freezFilter) {
					localStorage.setItem(
						`res-filters-${this.$el.id}`,
						JSON.stringify(this.filters)
					);
				}
				this.$emit("update:filters", val);
			},
			deep: true
		}
	}
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
